export class XmlHelper {
    /**
     * If the node is an element, it will add the element's attributes to the object, and then
     * recursively call itself on the element's children. If the node is a text node, it will add the
     * text to the object. If the node is neither an element nor a text node, it will do nothing.
     * @param {any} xml - any - Xml object
     * @returns xml with json format
     */
    static xmlToJson(xml) {
        let obj = {};
        if (xml.nodeType === 1) {
            if (xml.attributes.length > 0) {
                obj['@attributes'] = {};
                // eslint-disable-next-line no-plusplus
                for (let j = 0; j < xml.attributes.length; j++) {
                    const attribute = xml.attributes.item(j);
                    obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
                }
            }
        }
        else if (xml.nodeType === 3) {
            obj = xml.nodeValue;
        }
        if (xml.hasChildNodes()) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < xml.childNodes.length; i++) {
                const item = xml.childNodes.item(i);
                const { nodeName } = item;
                if (typeof (obj[nodeName]) === 'undefined') {
                    obj[nodeName] = this.xmlToJson(item);
                }
                else {
                    if (typeof (obj[nodeName].push) === 'undefined') {
                        const old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(this.xmlToJson(item));
                }
            }
        }
        return obj;
    }
    /**
     * It takes an XML string, converts it to an XML object, then converts that XML object to a JSON
     * object
     * @param {string} xmlString - The XML string to be parsed.
     * @returns The XML string is being parsed into a JSON object.
     */
    static parseXML(xmlString) {
        const parser = new DOMParser();
        const xml = parser.parseFromString(xmlString, 'application/xml');
        const json = this.xmlToJson(xml);
        return json;
    }
}
//# sourceMappingURL=xmlHelper.js.map